import { render, staticRenderFns } from "./CheckBox.vue?vue&type=template&id=f5665aec&scoped=true"
import script from "./CheckBox.vue?vue&type=script&lang=js"
export * from "./CheckBox.vue?vue&type=script&lang=js"
import style0 from "./CheckBox.vue?vue&type=style&index=0&id=f5665aec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5665aec",
  null
  
)

export default component.exports